import React from 'react';

export const GeoFlag = ({ size = 22, className = '' }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 640 480" 
        width={size} 
        height={Math.round(size * 0.75)} 
        className={className} 
        style={{ borderRadius: '3px', verticalAlign: 'middle', display: 'inline-block', boxShadow: '0 1px 3px rgba(0,0,0,0.25)' }}
    >
        <path fill="#fff" d="M0 0h640v480H0z"/>
        <path fill="#f00" d="M256 0h128v480H256zM0 176h640v128H0z"/>
        <g fill="#f00">
            <path d="M108 68h40v80h-40zM88 88h80v40H88z"/>
            <path d="M492 68h40v80h-40zM472 88h80v40h-80z"/>
            <path d="M108 332h40v80h-40zM88 352h80v40H88z"/>
            <path d="M492 332h40v80h-40zM472 352h80v40h-80z"/>
        </g>
    </svg>
);

export const UkFlag = ({ size = 22, className = '' }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 640 480" 
        width={size} 
        height={Math.round(size * 0.75)} 
        className={className} 
        style={{ borderRadius: '3px', verticalAlign: 'middle', display: 'inline-block', boxShadow: '0 1px 3px rgba(0,0,0,0.25)' }}
    >
        <path fill="#012169" d="M0 0h640v480H0z"/>
        <path fill="#fff" d="m75 0 245 180L565 0h75v50L440 240l200 150v90h-75L320 300 75 480H0v-50l200-150L0 90V0z"/>
        <path fill="#C8102E" d="m425 285 215 160v35h-30L395 315zM640 35 440 185l30 25 170-130zM0 445l200-150-30-25L0 400zM215 195 0 35V0h30l215 160z"/>
        <path fill="#fff" d="M240 0h160v480H240zM0 160h640v160H0z"/>
        <path fill="#C8102E" d="M266 0h108v480H266zM0 186h640v108H0z"/>
    </svg>
);

const Flags = { GeoFlag, UkFlag };
export default Flags;
